import { render, staticRenderFns } from "./Base-Template.vue?vue&type=template&id=7ea3304e&"
import script from "./Base-Template.vue?vue&type=script&lang=ts&"
export * from "./Base-Template.vue?vue&type=script&lang=ts&"
import style0 from "./Base-Template.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports